import '../../../../assets/css/screens/customer/dashboard/appservices/Bookservices.css';
import AppNavbar from '../../../../components/customer/dashboard/apphome/appnavbar/AppNavbar';
import AppContext from '../../../../context/AppContext';

import React, { useState, useRef, useContext } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import {
  ArrowLeft, Calendar, Clock,
  MapPin, Phone, Image as ImageIcon, FileText,
  CheckCircle, X, Plus
} from 'lucide-react'
import axios from 'axios';

const BookingPage = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const { baseUrl } = useContext(AppContext);
  const { categoryName } = location.state || {}

  const [date, setDate] = useState(new Date().toISOString().split('T')[0])
  const [time, setTime] = useState('')
  const [selectedAmPm, setSelectedAmPm] = useState('AM')
  const [address, setAddress] = useState('')
  const [city, setCity] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [job_description, setJob_Description] = useState('')
  const [hours, setHours] = useState('')
  const [media, setMedia] = useState([])
  const [loading, setLoading] = useState(false)

  const fileRef = useRef()

  const createbooking = () => {
    const formData = new FormData();
    formData.append("date", date);
    formData.append("time", time);
    formData.append("address", address);
    formData.append("city", city);
    formData.append("phoneNumber", phoneNumber);
    formData.append("job_description", job_description);
    formData.append("hours", hours);

    media.forEach((m) => {
      formData.append("media[]", m.file);
    });

    setLoading(true);

    axios.post(`${baseUrl}/customer/booking`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((res) => {
        setLoading(false);
        if (res.data.success) {
          alert("Booking confirmed ✅");
          navigate('/mybookings');
        } else {
          alert(res.data.error);
        }
      })
      .catch(() => {
        setLoading(false);
        alert("Network error!");
      });
  }

  const handleMedia = (e) => {
    const files = Array.from(e.target.files);

    const previewFiles = files.map(f => ({
      file: f,
      url: URL.createObjectURL(f),
      type: f.type.startsWith('video') ? 'video' : 'image',
    }));

    setMedia(p => [...p, ...previewFiles]);
  }

  const removeMedia = (i) => setMedia(p => p.filter((_, x) => x !== i))

  const specialty = categoryName
    ? categoryName.replace(' Services', '').replace(' Service', '')
    : 'Electrical'

  // ✅ SAME JSX (NO CHANGE)
  const renderForm = () => (
    <>
      {/* Worker summary */}
      <div className="bp-worker-card">
        <div className="bp-worker-avatar"></div>
        <div className="bp-worker-info">
          <span className="bp-worker-role">{specialty}</span>
        </div>
      </div>

      {/* Date */}
      <div className="bp-section">
        <div className="bp-section-label"><Calendar size={16} className="bp-section-icon" /> Select Date</div>
        <input type="date" className="bp-input" value={date}
          min={new Date().toISOString().split('T')[0]}
          onChange={e => setDate(e.target.value)} />
      </div>

      {/* Time */}
      <div className="bp-section">
        <div className="bp-section-label"><Clock size={16} className="bp-section-icon" /> Select Time</div>
        <div style={{ display: 'flex', gap: '10px' }}>
          <input type="time" className="bp-input" value={time}
            onChange={e => setTime(e.target.value)} style={{ flex: 1 }} />
          <select className="bp-input" value={selectedAmPm}
            onChange={e => setSelectedAmPm(e.target.value)} style={{ width: '100px' }}>
            <option value="AM">AM</option>
            <option value="PM">PM</option>
          </select>
        </div>
      </div>

      {/* Final Hours */}
      <div className="bp-section">
        <div className="bp-section-label"><Clock size={16} className="bp-section-icon" /> Final Hours</div>
        <input className="bp-input" type="number" min="0"
          placeholder="e.g., 3 (estimated hours for the job)"
          value={hours} onChange={e => setHours(e.target.value)} />
      </div>

      {/* Address */}
      <div className="bp-section">
        <div className="bp-section-label"><MapPin size={16} className="bp-section-icon" /> Service Address</div>
        <input className="bp-input" placeholder="Enter complete service address"
          value={address} onChange={e => setAddress(e.target.value)} />
      </div>

      {/* City */}
      <div className="bp-section">
        <div className="bp-section-label"><MapPin size={16} className="bp-section-icon" /> City</div>
        <input className="bp-input" placeholder="Enter city"
          value={city} onChange={e => setCity(e.target.value)} />
      </div>

      {/* Phone */}
      <div className="bp-section">
        <div className="bp-section-label"><Phone size={16} className="bp-section-icon" /> Phone Number</div>
        <input className="bp-input" type="tel" placeholder="Enter phone number"
          value={phoneNumber} onChange={e => setPhoneNumber(e.target.value)} />
      </div>

      {/* Description */}
      <div className="bp-section">
        <div className="bp-section-label"><FileText size={16} className="bp-section-icon" /> Job Description</div>
        <textarea className="bp-textarea" rows={4} placeholder="Describe the job in detail..."
          value={job_description} onChange={e => setJob_Description(e.target.value)} />
      </div>

      {/* Media upload */}
      <div className="bp-section">
        <div className="bp-section-label"><ImageIcon size={16} className="bp-section-icon" /> Upload Photos / Videos</div>
        <p className="bp-upload-hint">Upload images or videos to help the provider understand the job.</p>
        <div className="bp-media-row">
          {media.map((m, i) => (
            <div key={i} className="bp-media-thumb">
              {m.type === 'video'
                ? <video src={m.url} className="bp-media-thumb__img" />
                : <img src={m.url} alt="upload" className="bp-media-thumb__img" />}
              <button className="bp-media-thumb__del" onClick={() => removeMedia(i)}><X size={11} /></button>
            </div>
          ))}
          <button className="bp-upload-add" onClick={() => fileRef.current.click()}>
            <Plus size={20} /><span>Add</span>
          </button>
          <input ref={fileRef} type="file" accept="image/*,video/*" multiple
            style={{ display: 'none' }} onChange={handleMedia} />
        </div>
      </div>
    </>
  )

  return (
    <>
      <AppNavbar />

      {/* MOBILE */}
      <div className="bp-page bp-mobile-only">
        <div className="bp-header">
          <button className="bp-back" onClick={() => navigate(-1)}><ArrowLeft size={22} /></button>
          <h2 className="bp-header-title">Book Service</h2>
          <div style={{ width: 38 }} />
        </div>

        <div className="bp-body">
          {renderForm()}
          <div style={{ height: 90 }} />
        </div>

        <div className="bp-bottom-bar">
          <button className={`bp-confirm-btn ${loading ? 'bp-confirm-btn--loading' : ''}`}
            onClick={createbooking} disabled={loading}>
            {loading ? <><span className="bp-spinner" /> Confirming...</> : <><CheckCircle size={18} /> Confirm Booking</>}
          </button>
        </div>
      </div>

      {/* DESKTOP */}
      <div className="bp-desktop-only">
        <div className="bp-desktop-wrap">
          <div className="bp-desktop-card">

            <div className="bp-desktop-card__header">
              <button className="bp-back bp-desktop-back" onClick={() => navigate(-1)}>
                <ArrowLeft size={22} />
              </button>
              <h2 className="bp-desktop-card__title">Book Services</h2>
            </div>

            <div className="bp-desktop-card__fields">
              {renderForm()}
            </div>

            <div className="bp-desktop-card__footer">
              <button
                className={`bp-confirm-btn ${loading ? 'bp-confirm-btn--loading' : ''}`}
                onClick={createbooking}
                disabled={loading}
              >
                {loading
                  ? <><span className="bp-spinner" /> Confirming...</>
                  : <><CheckCircle size={18} /> Confirm Booking</>
                }
              </button>
            </div>

          </div>
        </div>
      </div>
    </>
  )
}

export default BookingPage;